import { Component, OnChanges, Input, SimpleChanges, OnInit } from '@angular/core';
import { takeUntil, Subject } from "rxjs";
import { ImportserialService } from '../../services/importserial.service';
import { AppMainService } from 'src/app/app-main.service';
import { DatePipe } from '@angular/common';
import { TransactionNames } from 'src/app/finance/constants/constants';
import { LocationsService } from 'src/app/inventory/locations/locations.service';
import { MessageService } from 'primeng/api';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { popupOpeningFields } from '../../enums/serial-details.enum';


@Component({
    selector: 'app-serial-details-block',
    templateUrl: './serial-details-block.component.html',
    styleUrls: ["./serial-details-block.component.scss"],
    providers: [LocationsService, MessageService],
})

export class SerialDetailsBlockComponent implements OnChanges,OnInit {

    @Input() selectedSerial;
    @Input() cols =[];
    @Input() serialTypeId: number;
    @Input() trackingOptions = [];
    detailsCol =[];
    serialDetails: any =null;
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    displayTransfer: boolean = false;
    displayAdjustment: boolean = false;
    isView = true;
    length: number  =0;
    inventoryAdjustmentId: number = 0;
    inventorytransferId: number = 0;
    selecteddVendor:any = null;
    displayOverview: boolean = false;
    isSelecteddVendor: boolean = false;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number = 0;
    selectedAccountChannelId: number = 0;
    loadingSpinner: boolean = false;
    displaylocationView : boolean = false;
    location: any;
    popupOpeningFields = popupOpeningFields;

    constructor(private importService:ImportserialService ,private appMainService: AppMainService,
        private datePipe: DatePipe,private locationService: LocationsService,private purchaseService: PurchasesService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedSerial?.currentValue) {
            this.loadData(this.selectedSerial.serialId ?? this.selectedSerial.id,this.serialTypeId);
        }
    }

    ngOnInit(){
      this.importService.getDecimalValue().subscribe(value => {
       if(value){
        this.length = value;
       }
      })
    }

    refreshData(){
        this.loadData(this.selectedSerial.serialId ?? this.selectedSerial.id,this.serialTypeId);
    }

    loadData(txnId: number,typeId: number) {
        this.appMainService.isShowSpinner("loadData");
        this.importService.getSerialOverviewData(txnId,typeId).pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.serialDetails = res['serialDetail'];
                    this.prepareData(res);
                    this.appMainService.isHideSpinner("loadData");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadData");
                },
            });
    }

    prepareData(data){
        /**product etail col**/
        const prdCols = JSON.parse(this.serialDetails?.column).map((col) => {
            return {
                labelname: col.header,
                field: col.field,
                checked: true,
                ischecked: true,
                dataType: col.datetype
            };
        });
        this.cols.push(...prdCols);
        this.cols = [...this.cols];
        for(let col of this.cols){
          switch (col.dataType) {
            case 'DatePicker':
            case 'datetime':
              this.serialDetails[`${col.field}`] = this.datePipe.transform(this.serialDetails[`${col.field}`], 'MM/dd/yyyy');
              break;
            case 'Currency':
              const formattedCurrencyValue = Number(this.serialDetails[`${col.field}`]).toFixed(col.decimal);
              this.serialDetails[`${col.field}`] = `${col.symbol} ${formattedCurrencyValue}`;
              break;
            case 'Decimal':
              const formattedDecimalValue = Number(this.serialDetails[`${col.field}`]).toFixed(col.decimal);
              this.serialDetails[`${col.field}`] = `${formattedDecimalValue}`;
              break;
            case 'Percentage':
              const formattedPercentageValue = Number(this.serialDetails[`${col.field}`]).toFixed(col.decimal);
              this.serialDetails[`${col.field}`]  = `${formattedPercentageValue}%`;
              break;
          }
        }
       
        this.detailsCol = [];
        let arr = [];
        const sections =['adjustmentDetail','transferDetail','itemReceiptDetail','billDetail','salesOrderDetail','invoiceDetail','creditMemoDetail','rmaDetail','vendorRmaDetail','vendorCreditDetail'];
        for(let sec of sections){
            if(data[`${sec}`]){
                data[`${sec}`].section = JSON.parse(data[`${sec}`]?.column);
                arr.push(data[`${sec}`]);
            }
        }
        for(let i=0; i<arr.length; i += 2){
            this.detailsCol.push(arr.slice(i, i + 2))
        }
    }
    
    isPopupAllowed(field: string): boolean {   
     return this.popupOpeningFields?.includes(field);
    }

    detailsView(rowData: any, str: string) {
        if (str == 'adjustmentNumber') {
          this.inventoryAdjustmentId = rowData.adjustmentId;
          this.displayAdjustment = true;
        } else if (str == 'transferNumber') {
          this.inventorytransferId = rowData.transferId;
          this.displayTransfer = true;
        } else if (str == 'billNumber') {
          this.inventoryOverviewRefId = rowData.billId;
          this.inventoryOverviewRefNumber = rowData.billNumber;
          this.inventoryOverviewModule = TransactionNames.Bill;
          this.displayInventoryOverview = true;
        } else if (str == 'itemReceiptNumber') {
          this.inventoryOverviewRefId = rowData.itemReceiptId;
          this.inventoryOverviewRefNumber = rowData.itemReceiptNumber;
          this.inventoryOverviewModule = TransactionNames.ItemReceipt;
          this.displayInventoryOverview = true;
        } else if (str == 'invoiceNumber') {
          this.inventoryOverviewRefId = rowData.invoiceId;
          this.inventoryOverviewRefNumber = rowData.invoiceNumber;
          this.inventoryOverviewModule = TransactionNames.Invoice;
          this.displayInventoryOverview = true;
        } else if (str == "salesOrderNumber") {
          this.inventoryOverviewRefId = rowData.salesOrderId;
          this.inventoryOverviewRefNumber = rowData.salesOrderNumber;
          this.inventoryOverviewModule = TransactionNames.SalesOrder;
          this.displayInventoryOverview = true;
        } else if (str == "purchaseNumber") {
          this.inventoryOverviewRefId = rowData.purchaseOrderId;
          this.inventoryOverviewRefNumber = rowData.purchaseNumber;
          this.inventoryOverviewModule = TransactionNames.PurchaseOrder;
          this.displayInventoryOverview = this.inventoryOverviewRefNumber != "N/A";
        } else if (str == "accountName") {
          this.selectedAccountId = rowData.accountId;
          this.selectedAccountChannelId = rowData.channelId;
          this.displayAccountViewEdit = true;
        } else if (str == "rmaNumber") {
          this.inventoryOverviewRefId = rowData.rmaId;
          this.inventoryOverviewRefNumber = rowData.rmaNumber;
          this.inventoryOverviewModule = TransactionNames.CustomerRMA;
          this.displayInventoryOverview = true
        } else if (str == "creditMemoNumber") {
          this.inventoryOverviewRefId = rowData.creditMemoId;
          this.inventoryOverviewRefNumber = rowData.creditMemoNumber;
          this.inventoryOverviewModule = TransactionNames.CreditMemo;
          this.displayInventoryOverview = true
        } else if (str == "vendorCreditNumber") {
          this.inventoryOverviewRefId = rowData?.vendorCreditId;
          this.inventoryOverviewRefNumber = rowData?.vendorCreditNumber;
          this.inventoryOverviewModule = TransactionNames.VendorCredit;
          this.displayInventoryOverview = true
        } else if (str == "vendorRMANumber") {
          this.inventoryOverviewRefId = rowData?.vendorRMAId;
          this.inventoryOverviewRefNumber = rowData?.vendorRMANumber;
          this.inventoryOverviewModule = TransactionNames.VendorRMA;
          this.displayInventoryOverview = true
        } else if(str === 'warehouseName'){
          this.displaylocationView = false;
          this.locationView(rowData.warehouseId);
        } else if(str === 'vendorName'){
          this.isSelecteddVendor = false;
          this.getVendor(rowData)

        }
      }

 getVendor(rowData){
    this.loadingSpinner = true ;
    this.purchaseService.getVendorById(rowData.vendorId).subscribe(vendor => {
      this.loadingSpinner = false ;
      this.selecteddVendor = vendor;
      this.isSelecteddVendor = true;
  })
  }
     
  onDialogClose() {
    this.displayAdjustment = false;
    this.displayTransfer = false;
    this.displayOverview = false;
    this.displayAccountViewEdit = false;
  }

  closeViewPopup() {
    this.displayInventoryOverview = false;
  }

  locationView(id){
    this.loadingSpinner = true ;
    this.locationService.getLocationById(id).subscribe((location) => {
    this.loadingSpinner = false ;
      this.location = location;
      this.displaylocationView = true;
    });
  }

  closeAccountViewEditModal() {
    this.loadData(this.selectedSerial.serialId ?? this.selectedSerial.id,this.serialTypeId);
    this.displayAccountViewEdit = false;
    this.selectedAccountId = 0;
    this.selectedAccountChannelId = 0;
  }

closeLocationView(data: any) {
  this.displaylocationView = data
  this.loadData(this.selectedSerial.serialId ?? this.selectedSerial.id,this.serialTypeId);
}

openLocationDialog(id: number) {
 this.displaylocationView = false;
 this.locationView(id);
}

resetDialog(value) {
  this.loadData(this.selectedSerial.serialId ?? this.selectedSerial.id,this.serialTypeId);
  this.isSelecteddVendor = false;
}

}



